import { combineReducers } from 'redux';

import { SET_RESET_PASSWORD_EMAIL_STATUS } from '../actions/forgotPassword';
import { SET_SOFT_ACCOUNT_EMAIL_STATUS } from '../actions/softAccount';
import { SET_SIGNUP_SECOND_STEP } from '../actions/lookup';

const resetPasswordEmailStatus = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_RESET_PASSWORD_EMAIL_STATUS) {
        nextState = payload;
    }
    return nextState;
};

const softAccountEmailStatus = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_SOFT_ACCOUNT_EMAIL_STATUS) {
        nextState = payload;
    }
    return nextState;
};

const signUpSecondStep = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_SIGNUP_SECOND_STEP) {
        nextState = payload;
    }
    return nextState;
};

export default combineReducers({
    resetPasswordEmailStatus,
    softAccountEmailStatus,
    signUpSecondStep,
});
